export const CARGAR_GENERAL="cargar_general";
export const CARGANDO="general_cargando";
export const ERROR="general_error";
